import Axios from "axios";

export class AccionistaBvgService {

    lista(params) {
        const queryParams = params ? Object.keys(params).map(k => encodeURIComponent(k) + '=' + encodeURIComponent(params[k])).join('&') : '';
        return Axios.get(`${process.env.REACT_APP_URL_BACK}/ficha/accionista-bvg/lista?${queryParams}`).then(res => res.data);
    }

    newAccionista(data) {
        return Axios.post(`${process.env.REACT_APP_URL_BACK}/ficha/accionista-bvg/nuevo`, data).then(res => res.data);
    }

    editar(data) {
        return Axios.put(`${process.env.REACT_APP_URL_BACK}/ficha/accionista-bvg/editar`, data).then(res => res.data);
    }

    eliminar(id, idp) {
        return Axios.delete(`${process.env.REACT_APP_URL_BACK}/ficha/accionista-bvg/eliminar/${id}/${idp}`).then(res => res.data);
    }

    consultar(id, idp) {
        return Axios.get(`${process.env.REACT_APP_URL_BACK}/ficha/accionista-bvg/consulta/${id}/${idp}`).then(res => res.data);
    }
}
